import { InputAdornment, IconButton } from '@mui/material';
import React, {useEffect} from 'react';
import SearchIcon from '@mui/icons-material/Search';
import {CustomTextField} from "../CustomTextField";
import {debounce} from "lodash";
import {DEBOUNCE_DELAY} from "../../Apis/functions";
import { CloseIcon } from '../buttons/IconButtons';
const CustomSearch = ({
    id,
    label,
    value,
    setValue,
    disabled=false,
    length=180,
    required=false,
    onChange,
    onSearchIcon,
    onReset,
    searchFunction=() =>{},
    setSendSimpleSearch,
}) => {

    useEffect(() => {
        const debouncedFilter = debounce(() => {
            searchFunction(value);
        }, DEBOUNCE_DELAY);

        debouncedFilter();
        return () => debouncedFilter.cancel();
    }, [value]);

    return (
        <CustomTextField id={id}
                         trans={label}
                         type={"text"}
                         onChange={onChange}
                         value={value}
                         disabled={disabled}
                         length={length}
                         required={required}
                         showCounter={false}
                         onFocus={() => setSendSimpleSearch && setSendSimpleSearch(true)}
                         InputProps={{
                             endAdornment: (
                                 <>
                                     <InputAdornment position='end'>
                                         <SearchIcon onClick={onSearchIcon} />
                                     </InputAdornment>
                                     {value && (
                                         <InputAdornment position='end'>
                                             <IconButton onClick={() => {
                                                 setValue("");
                                                 onReset();
                                                }}>
                                                 <CloseIcon  className={'w-16px'}/> 
                                             </IconButton>
                                         </InputAdornment>
                                     )}
                                 </>
                             ),
                         }}
        />
    );
};

export default CustomSearch;
